import { useSplitTreatments } from '@splitsoftware/splitio-react';
// constants
import { FEATURE_MODES } from '../constants/ab-testing.constants';
import { useSplitAmplitude } from '../contexts/ABTestingProvider/hooks/useSplitAmplitude';
export default function useAB(flag, attributes) {
    var _a, _b, _c, _d;
    if (attributes === void 0) { attributes = {}; }
    var _e = useSplitTreatments({
        names: [flag],
        attributes: attributes
    }), treatments = _e.treatments, isReady = _e.isReady;
    useSplitAmplitude({
        isReady: isReady,
        experimentName: flag,
        treatment: (_a = treatments[flag]) === null || _a === void 0 ? void 0 : _a.treatment
    });
    return {
        isReady: isReady,
        active: ((_b = treatments[flag]) === null || _b === void 0 ? void 0 : _b.treatment) === FEATURE_MODES.ON,
        config: (_d = (_c = treatments[flag]) === null || _c === void 0 ? void 0 : _c.config) !== null && _d !== void 0 ? _d : null
    };
}
//# sourceMappingURL=useAB.js.map